import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

// ============================================================================
// LAS VENTAS DE UN DÍA POR SUCURSAL — `daily-sales` (plan de Gastos §5.3, F5).
//
// Las escribe SOLO el server: el aseo diario (los 3 días cerrados de su ventana)
// y el relleno histórico, con la misma regla (`krispis-server/src/api/Cron/
// DailySales.ts`). Aquí solo se leen. Un documento por sucursal y día, aunque no
// haya vendido (0 = cero, no "falta"). Id: `{branchOfficeId}_{yyyy-MM-dd}`.
// ============================================================================

export interface DailySales {
    branchOfficeId: string;
    /** `yyyy-MM-dd`, México. */
    day: string;
    /** Pedidos `Completed` del día. */
    orders: number;
    subtotal: number;
    promotion: number;
    points: number;
    shipping: number;
    tips: number;
    total: number;
    /** subtotal − promoción − puntos: sin propina (no es venta) y sin envío (renglón propio). */
    netSales: number;
    /** v2 (plan de inventario F3): Σ `amount` de las mermas registradas ese día. Ausente en los v1 = 0. */
    shrinkage?: number;
    /** v2: Σ (diferencia × costo) de los conteos NO baseline; negativo = faltante. Ausente = 0. */
    countDifference?: number;
    schemaVersion: number;
    updatedAt?: any;
}

export const DAILY_SALES_COLLECTION = 'daily-sales';
export const dailySalesRef = collection(firestore, DAILY_SALES_COLLECTION);
